import { colors } from '@/lib/analytics/colors';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalInteractionsConfig = {
    name: 'kpi.instagram.reel_engagement',
    id: 'engagements',
    icon: {
        name: 'reel-interactions',
        style: colors.pink
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_FULL,
    type: 'kpi',
    loader: DefaultLoader,
    noDataToken: 'analytics:kpi.instagram.no_posts_period',
    element: KPIDefault
};
